var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9286 17H13.0714C11.9916 17 10.956 17.432 10.1925 18.2009C9.42895 18.9698 9 20.0126 9 21.1V53.9C9 54.9874 9.42895 56.0302 10.1925 56.7991C10.956 57.568 11.9916 58 13.0714 58H61.9286C63.0084 58 64.044 57.568 64.8075 56.7991C65.571 56.0302 66 54.9874 66 53.9V21.1C66 20.0126 65.571 18.9698 64.8075 18.2009C64.044 17.432 63.0084 17 61.9286 17ZM57.45 21.1L37.5 34.999L17.55 21.1H57.45ZM13.0714 53.9V22.9655L36.3396 39.181C36.6804 39.4191 37.0853 39.5466 37.5 39.5466C37.9147 39.5466 38.3196 39.4191 38.6604 39.181L61.9286 22.9655V53.9H13.0714Z",
    fill: "#F12602"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.6fed52b7c84a5d67a277a1e587353b26.svg";
export { ForwardRef as ReactComponent };